<template>
  <div
    v-if="lesson"
    class="home-lesson-slide book-cover"
    :class="lesson.is_month ? 'month' : ''"
  >
    <router-link :to="to">
      <img :src="img" class="img-fluid" />
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    lesson: {
      type: Object,
      default: () => ({})
    },
    trail: [Number, String]
  },
  computed: {
    img() {
      // if (this.lesson.is_month) {
      //   return (
      //     this.lesson.web_cover ||
      //     this.lesson.cover_horizontal ||
      //     this.lesson.cover
      //   );
      // }
      // return this.lesson.ca_cover;
      return this.lesson.app_cover || this.lesson.ca_cover;
    },
    to() {
      const name = this.trail ? "trail-lesson" : "lesson";
      return {
        name,
        params: {
          trail: this.trail,
          ...this.lesson
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.home-lesson-slide {
  position: relative;
  margin: 8px;

  @media screen and (max-width: 991px) {
    width: fit-content;
  }

  &::before {
    content: "";
    height: 100%;
    background: #131212;
    opacity: 0.1;
    border-radius: 5px;
    width: 5px;
    z-index: 999;

    position: absolute;
    left: 1%;
    top: -1%;
    bottom: 0;
  }

  img {
    width: 100%;
    border-radius: 3px;
  }

  a {
    font-size: 14px;
  }
}
</style>
